import * as React from 'react'
import { Outlet } from 'react-router'
import { NavigationBar } from '../NavigationBar'
import { Sidebar } from '../Sidebar'
import styles from './MainLayout.module.css'

export function MainLayout() {
  const [isSidebarVisible, setIsSidebarVisible] = React.useState(() => window.innerWidth >= 640)

  return (
    <main className="surface-50 min-h-screen">
      <NavigationBar />
      <div className={`px-3 sm:px-5 ${isSidebarVisible ? '' : 'xl:mt-0 mt-8'}`}>
        <div className="sm:flex sm:flex-row max-w-app mx-auto pb-8">
          <SidebarWrapper isSidebarVisible={isSidebarVisible} toggleSidebar={() => setIsSidebarVisible(prev => !prev)} />
          <div className={`flex-grow-1 min-w-0 ${isSidebarVisible ? 'sm:ml-3' : 'ml-0'}`}>
            <Outlet />
          </div>
        </div>
      </div>
    </main>
  )
}

function SidebarWrapper({ isSidebarVisible, toggleSidebar }: { isSidebarVisible: boolean, toggleSidebar: () => void }) {
  const sidebarClasses = `sm:w-18rem sm:flex-none mb-3 sm:mb-0 ${
    isSidebarVisible ? 'relative' : `fixed -translate-x-100 left-0 z-1 lg:left-0 ${styles.sidebarHidden}`
  }`

  const buttonClasses = `border-none top-0 right-0 p-3 bg-transparent flex cursor-pointer ${
    isSidebarVisible ? 'absolute' : 'bg-white shadow-1 relative left-100 border-round-right-sm'
  }`

  return (
    <div className={sidebarClasses}>
      <button className={buttonClasses} onClick={toggleSidebar} type="button">
        <SidebarToggleIcon />
      </button>
      <Sidebar />
    </div>
  )
}

function SidebarToggleIcon() {
  return (
    <svg width="21" height="15" viewBox="0 0 21 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.16669 13.6455V0.852829" stroke="#64748B" strokeWidth="1.5" />
      <rect x="1.25" y="0.75" width="18.5" height="13.2826" rx="2.25" stroke="#64748B" strokeWidth="1.5" />
    </svg>
  )
}
